export default __webpack_public_path__ + "static/media/image2.7602e043.jpg";